import { render, staticRenderFns } from "./businessModal.vue?vue&type=template&id=5371cc40&"
import script from "./businessModal.vue?vue&type=script&lang=js&"
export * from "./businessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports